import Phaser from 'phaser';
import { GAME_W, GAME_H } from './utils/MobileHelper';
import { BootScene } from './scenes/BootScene';
import { MapScene } from './scenes/MapScene';
import { CombatScene } from './scenes/CombatScene';
import { LootScene } from './scenes/LootScene';
import { EquipScene } from './scenes/EquipScene';
import { RunVictoryScene } from './scenes/RunVictoryScene';
import { EventScene } from './scenes/EventScene';
import { ShopScene } from './scenes/ShopScene';
import { ExploreScene } from './scenes/ExploreScene';
import { DevScene } from './scenes/DevScene';
import { StatsScene } from './scenes/StatsScene';
import { CampScene } from './scenes/CampScene';
import { StorageScene } from './scenes/StorageScene';
import { DormScene } from './scenes/DormScene';
import { SurvivorScene } from './scenes/SurvivorScene';
import { RunEndScene } from './scenes/RunEndScene';
import { RunPrepScene } from './scenes/RunPrepScene';
import { AtelierScene } from './scenes/AtelierScene';
import { VigieScene } from './scenes/VigieScene';
import { ExpeditionResultScene } from './scenes/ExpeditionResultScene';
import { ExtractScene } from './scenes/ExtractScene';
import { CodexScene } from './scenes/CodexScene';
import { SettingsScene } from './scenes/SettingsScene';
import { CreditsScene } from './scenes/CreditsScene';
import { TavernScene } from './scenes/TavernScene';
import { RoadmapScene } from './scenes/RoadmapScene';
import { PatchNotesScene } from './scenes/PatchNotesScene';
import { LeaderboardScene } from './scenes/LeaderboardScene';
import { IslandCampScene } from './scenes/IslandCampScene';

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: GAME_W,
  height: GAME_H,
  backgroundColor: '#16213e',
  pixelArt: true,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    expandParent: true,
  },
  input: {
    activePointers: 2, // Support multi-touch basique
  },
  // Indispensable pour `canvas.toBlob()` côté bug report : sans ça, le buffer
  // WebGL est effacé après chaque frame → les screenshots ressortent en noir.
  // Coût perf marginal pour notre rendu (rectangles + sprites SVG).
  render: {
    preserveDrawingBuffer: true,
  },
  scene: [BootScene, CampScene, IslandCampScene, RunPrepScene, MapScene, CombatScene, LootScene, EquipScene, RunVictoryScene, RunEndScene, EventScene, ShopScene, ExploreScene, SurvivorScene, DevScene, StatsScene, StorageScene, DormScene, AtelierScene, VigieScene, ExpeditionResultScene, ExtractScene, CodexScene, SettingsScene, CreditsScene, TavernScene, RoadmapScene, PatchNotesScene, LeaderboardScene],
};
